/** Interface for UI components that mutate or need to pass
 * reference or certain data to their parents
 */
export interface UIEvent {
  currentTarget?: string;
  target: string;
  value: string | boolean;
  type?: string;
  label?: string;
  index?: number;
}
